import React from "react";
import BreadcrumbsItem from "./../../atoms/breadcrumbsItem/index.jsx";
import classnames from "classnames";

import "./styles.scss";

export default class Breadcrumbs extends React.Component {
  render() {
    const type = this.props.type,
      vehicleName = `${this.props.vehicle.brand} ${this.props.vehicle.name}`;

    return (
      <div className={classnames("breadcrumbs", type)}>
        <div className="container">
          <div className="col">
            <BreadcrumbsItem text="Usados" />
            <BreadcrumbsItem text={vehicleName} />
          </div>
        </div>
      </div>
    );
  }
}
